import React from "react";
import { Link } from "react-router-dom";
import { FolderPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NoProject({ message }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 animate-float-up" data-testid="no-project-state">
      <div className="w-16 h-16 rounded-2xl bg-primary/15 flex items-center justify-center mb-5">
        <FolderPlus className="w-8 h-8 text-primary" />
      </div>
      <h3 className="text-xl font-bold mb-2">لا يوجد مشروع نشط</h3>
      <p className="text-muted-foreground max-w-md mb-6">
        {message || "أنشئ مشروعك الأول للبدء في توليد الاستراتيجيات والمحتوى."}
      </p>
      <Link to="/app/projects">
        <Button className="bg-primary hover:bg-primary/90 text-white gap-2" data-testid="create-first-project">
          <FolderPlus className="w-4 h-4" /> إنشاء مشروع جديد
        </Button>
      </Link>
    </div>
  );
}
